export const leicaColors = {
  100: "#fdf9df",
  200: "#EFCF0A",
  300: "#dec107",
  400: "#c0a702",
  500: "#a38d01",
  600: "#867503",
  700: "#6a5d04",
  800: "#504704",
  900: "#383100",
};

export const pangeaUIColors = {
  grey: {
    "350": "#CCCCCC",
    "700": "#616161",
    "800": "#424242",
    "850": "#313131",
    "900": "#212121",
    darkGrey: "#121212",
  },
  white: "#FFFFFF",
  black: "#000000",
  whiteOp: {
    "600": "rgba(255, 255, 255, 0.46)", // white 46%,
    "700": "rgba(255, 255, 255, 0.38)", // white 38%,
    "850": "rgba(255, 255, 255, 0.19)", // white 19%
    "900": "rgba(255, 255, 255, 0.13)", // white 13%
  },
  blackOp: {
    "200": "rgba(0, 0, 0, 0.07)", // black 7%
    "300": "rgba(0, 0, 0, 0.12)", //black 12%
  },
};
